export const trainingSourceDetailsConstante = Object.freeze({
  SOURCE_DETAIL_ROME: 1,
  SOURCE_DETAIL_ESCO: 2,
  SOURCE_DETAIL_OFFER: 3,
  SOURCE_DETAIL_BOOKLET: 4,
});
